import React from "react";
import { Box, Typography, Avatar, Chip } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

const UserStatsCard = ({ username, avatarUrl, stats, colors }) => {
  if (!stats || stats.totalSessions === 0) {
    return (
      <Box
        sx={{
          p: 2,
          borderRadius: 2,
          bgcolor: "action.hover",
          border: "1px solid",
          borderColor: "divider",
          textAlign: "center",
        }}
      >
        <Avatar
          src={avatarUrl}
          alt={username}
          sx={{ width: 60, height: 60, mx: "auto", mb: 1 }}
        />
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
          {username}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Sin sesiones registradas
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        bgcolor: "action.hover",
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
        <Avatar
          src={avatarUrl}
          alt={username}
          sx={{ width: 60, height: 60 }}
        />
        <Box sx={{ flex: 1 }}>
          <Typography variant="subtitle2" fontWeight="bold">
            {username}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {stats.totalSessions} sesiones
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <TrendingUpIcon fontSize="small" color="primary" />
          <Typography variant="body2" sx={{ flex: 1 }}>
            Promedio reps:
          </Typography>
          <Chip
            label={stats.avgReps.toFixed(1)}
            size="small"
            color="primary"
            variant="outlined"
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <FitnessCenterIcon fontSize="small" color="secondary" />
          <Typography variant="body2" sx={{ flex: 1 }}>
            Promedio peso:
          </Typography>
          <Chip
            label={`${stats.avgWeight.toFixed(1)} kg`}
            size="small"
            color="secondary"
            variant="outlined"
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <EmojiEventsIcon fontSize="small" sx={{ color: "gold" }} />
          <Typography variant="body2" sx={{ flex: 1 }}>
            Récord:
          </Typography>
          <Chip
            label={`${stats.maxReps} × ${stats.maxWeight.toFixed(1)} kg`}
            size="small"
            sx={{ bgcolor: "gold", color: "black", fontWeight: "bold" }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default UserStatsCard;
